import { useMemo } from 'react';
import { defineHubSection, type HubSectionData } from '@/components/Hub/hubSectionTypes';
import { SpotlightCard } from '@/components/Spotlight/SpotlightCard';
import { useSpotlights } from '@/hooks/cms/useSpotlights';
import { cn } from '@/lib/utils';

const useSpotlightData = (): HubSectionData => {
    const { cards, isLoading, error } = useSpotlights();

    const slides = useMemo(
        () => cards.map(card => ({
            id: card.slug,
            render: () => <SpotlightCard card={card} />,
        })),
        [cards],
    );

    return { slides, isLoading, isError: Boolean(error) };
};

export const spotlightSection = defineHubSection({
    id: 'spotlight',
    title: 'Spotlight',
    blurb: 'Stay in the loop with the latest updates.',
    viewAll: null,
    endCard: null,
    itemBasisClassName: 'flex basis-[86%] sm:basis-[82%]',
    surfaceClassName: cn(
        'bg-gz-gold-100 dark:bg-gz-blue-800 !py-8',
        'text-gz-neutral-900 dark:text-gz-neutral-100',
        // The blurb only. A blanket `p` color would override the card description.
        '[&>div>p]:!text-gz-neutral-700 dark:[&>div>p]:!text-gz-neutral-100',
    ),
    useData: useSpotlightData,
});
